import { render, staticRenderFns } from "./FavoritePlaces.vue?vue&type=template&id=ea8231f2"
import script from "./FavoritePlaces.vue?vue&type=script&lang=ts"
export * from "./FavoritePlaces.vue?vue&type=script&lang=ts"
import style0 from "./FavoritePlaces.vue?vue&type=style&index=0&id=ea8231f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports